<div class="auth-container">
  <div class="auth-background">
    <div class="gradient-orb gradient-orb-1"></div>
    <div class="gradient-orb gradient-orb-2"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <!-- Top bar: Brand + Theme-Toggle -->
      <div class="desk-top">
        <div class="fp-brand">
          <img
            src="../../../../../assets/img/logo-text.svg"
            alt="FixPlaner"
            class="logo"
          />
        </div>
        <div class="auth-top-actions">
          <xds-icon-button
            [icon]="'fa-light ' + getThemeIconClass()"
            [ariaLabel]="'REG_THEME_TOGGLE_LABEL' | translate"
            (clicked)="toggleTheme()"
          ></xds-icon-button>
        </div>
      </div>

      <!-- Greeting — H1 + Lede (Eyebrow weg, Page-Zweck offensichtlich) -->
      <div class="desk-greet">
        <h1>
          {{ "FORGOT_PW_GREET_LINE_1" | translate }}
          <span class="grad">{{ "FORGOT_PW_GREET_BRAND" | translate }}</span>
        </h1>
        <p class="lede">{{ "FORGOT_PW_GREET_LEDE" | translate }}</p>
      </div>

      <!-- Form -->
      <form #form="ngForm" (submit)="onSubmit(form)" class="auth-form xds-form-stack">
        <xds-form-field
          labelKey="EMAIL"
          [required]="true"
          for="fp-email"
          [invalid]="Email.invalid && (Email.touched || form.submitted)"
        >
          <xds-input
            id="fp-email"
            type="email"
            placeholderKey="ENTER_YOUR_EMAIL"
            testId="forgot-password-email"
            #Email="ngModel"
            name="Email"
            [(ngModel)]="formModel.Email"
            [invalid]="Email.invalid && (Email.touched || form.submitted)"
            iconLeft="fa-light fa-envelope"
            required
            email
            autocomplete="email"
          ></xds-input>
        </xds-form-field>

        <!-- Error Message -->
        <xds-banner *ngIf="errorStatus.showError" variant="danger">{{ errorStatus.errorMessage }}</xds-banner>

        <!-- Actions -->
        <div class="desk-actions">
          <xds-button
            variant="primary"
            type="submit"
            iconRight="fa-light fa-paper-plane"
            data-testid="forgot-password-submit"
            [disabled]="!form.valid"
          >
            {{ "SEND_RESET_LINK" | translate }}
          </xds-button>
          <p class="helper">
            <a [routerLink]="['/login']">
              <i class="fa-light fa-arrow-left"></i>
              {{ "BACK TO LOGIN" | translate }}
            </a>
          </p>
        </div>
      </form>
    </div>
    <app-auth-legal-footer></app-auth-legal-footer>
  </div>
</div>
